module.exports = __webpack_public_path__ + "static/img/resume-cv-professionnel.18f9783.png";